import LFO from '../Images/LFO.jpg'
import UCLA from '../Images/UCLA.jpg'

export const EducationSection = () => {
    return (
        <div class="Section EducationSection" id="education">
            <div class="SectionTitle"><h2>Education 🎓</h2></div>
            <div class="CardGrid EducationGrid">
                <div class="Card">
                    <img src={UCLA}/>
                    <h3>University of California, Los Angeles</h3>
                    <h4>Mathematics of Computation, B.S.</h4>
                    <h5>2022 - 2026 (expected)</h5>
                    <h4>Relevant coursework</h4>
                    <p>- Introduction to Computer Science I<br/>- Differential & Integral Calculus</p>
                    <h4>Clubs & Activities</h4>
                    <p>- Association of Computing Machinery (ACM): general member<br/>- UCLA Triathlon<br/>- International Student Mentorship Program<br/>- Association of Computing Machinery (ACM) Cybersecurity intern</p>
                </div>
                <div class="Card">
                    <img src={LFO}/>
                    <h3>The French School of Oslo</h3>
                    <h4>French Baccalaureate</h4>
                    <h5>2019 - 2022</h5>
                    <h4>Relevant coursework</h4>
                    <p>- Multivariate calculus<br/>- Complex Number theory</p>
                    <h4>Awards & Distinctions</h4>
                    <p>- Received Norwegian Math Olympiad diploma<br/>- Selected to represent school at the French Math Olympiad<br/>- Second place in team game development contest (La nuit du code)</p>
                    <h4>Activities</h4>
                    <p>- Student delegate</p>
                </div>
            </div>
            <p><br></br></p>
        </div>
    )
}